var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiv8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.78125,
    width: 46,
    height: 46,
    rx: 13,
    fill: "#06BA63"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.739 19.3756C32.8021 21.1865 33.2368 23.2981 32.9756 25.3817C32.7144 27.4653 31.7719 29.4042 30.2947 30.8966C28.8174 32.3891 26.8884 33.3515 24.8075 33.6341C22.7267 33.9167 20.6108 33.5037 18.789 32.4593C16.9673 31.4149 15.5418 29.7977 14.7343 27.8592C13.9268 25.9207 13.7826 23.7697 14.3242 21.7408C14.8658 19.712 16.0627 17.9189 17.7288 16.6407C19.3949 15.3625 21.4367 14.6708 23.5366 14.6732C25.2518 14.6704 26.9352 15.1355 28.4057 16.0185L30.1319 14.2804C27.6522 12.636 24.6501 11.9715 21.7081 12.4158C18.7661 12.8601 16.0941 14.3815 14.2106 16.6848C12.3271 18.9881 11.3664 21.9089 11.515 24.8806C11.6636 27.8522 12.9108 30.6626 15.0147 32.7665C17.1186 34.8704 19.9291 36.1177 22.9007 36.2663C25.8723 36.4148 28.7932 35.4542 31.0964 33.5707C33.3997 31.6872 34.9211 29.0151 35.3654 26.0732C35.8097 23.1312 35.1452 20.1291 33.5009 17.6494L31.739 19.3756Z",
    fill: "#69D5A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4985 25.8943L19.0938 21.4896L20.7723 19.7991L23.4985 22.5372L33.3794 12.6562L35.058 14.3467L23.4985 25.8943Z",
    fill: "#F3F3F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6622 13.5H22.2812V17.0714H24.6622V13.5Z",
    fill: "#F3F3F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6622 31.4062H22.2812V34.9777H24.6622V31.4062Z",
    fill: "#F3F3F3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2902 23.0625H30.7188V25.4434H34.2902V23.0625Z",
    fill: "#F3F3F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3839 23.0625H12.8125V25.4434H16.3839V23.0625Z",
    fill: "#F3F3F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiv8);
export default __webpack_public_path__ + "static/media/div8.bedafbaccca5540582ed33ec6ae79c2d.svg";
export { ForwardRef as ReactComponent };